import { Box, styled, InputBase, IconButton } from "@mui/material";
import { useQueryClient } from "@tanstack/react-query";
import Button from "components/ui/Button";
import { useGlobalContext } from "context/GlobalContext";
import SortContext from "context/SortContext";
import { removeCollections, updateCollectionNames } from "features/collection/components/CollectionProductScreen/api/getCollectionProducts";
import { useUpdateSet } from "features/set/api/update-set";
import { useRemoveDesings } from "features/set/hooks/useRemoveDesigns";
import React, { useContext, useEffect, useState } from "react";
import { toast } from "react-toastify";
import { ReactComponent as SearchIconPlaceHolder } from "assets/icons/searchicon.svg";

import { useLocation, useNavigate, useParams, useSearchParams } from "react-router-dom";
import RemoveModal from "components/ui/RemoveModal/RemoveModal";
import { useDispatch, useSelector } from "react-redux";
import { clearEditCategory } from "store/cartSlice";

const CancelButton = styled(Button)(({}) => ({
  fontFamily: "Poppins",
  fontWeight: 500,
  fontSize: "18px",
  lineHeight: "22px",
  height: "42px",
  borderRadius: "5px",
  color: "#E77B7B",
  border: "1px solid #E77B7B",
  textTransform: "none",
  backgroundColor: "transparent",
  "&:hover": {
    backgroundColor: "#E77B7B",
    color: "black",
  },
}));

const StyledButton = styled(Button)(({ bgcolor, variant, disabled }) => ({
  fontFamily: "Poppins",
  fontWeight: 500,
  fontSize: "18px",
  lineHeight: "22px",
  height: "40px",
  borderRadius: "5px",
  color: `${variant === "save-change" ? "#50C878" : "#ffffff"}`,
  border: `1px solid ${variant === "save-change" ? "#50C878" : "#ffffff"}`,
  textTransform: "none",
  backgroundColor: "transparent",
  "&:hover": {
    backgroundColor: "#50C878",
    color: "black",
  },
  "&.Mui-disabled": {
    backgroundColor: "#000000",
    color: "#8B8B8B",
    border: "1px solid #8B8B8B",
  },
}));

const Search = styled("div")(({ theme }) => ({
  position: "relative",
  borderRadius: theme.shape.borderRadius,
  backgroundColor: "#FFFFFF",
  "&:hover": {
    backgroundColor: "#f0f0f0",
  },
  marginLeft: 0,
  width: "100%",
  boxShadow: "inset 0px 4px 20px 0px #00000040",
  [theme.breakpoints.up("sm")]: {
    marginLeft: theme.spacing(1),
    width: "auto",
  },
}));

const StyledInputBase = styled(InputBase)(({ theme }) => ({
  color: "black",
  height: "40px",
  "& .MuiInputBase-input": {
    padding: theme.spacing(1, 1, 1, 1),
    transition: theme.transitions.create("width"),

    width: "100%",
    [theme.breakpoints.up("md")]: {
      width: "40ch",
    },
  },
}));

const EditSetHeader = () => {
  const queryClient = useQueryClient();
  const { setIsEdit, setIsEditClick, setSearch, search, isCollectionEdit, setIsCollectionEdit } = useContext(SortContext);
  // const { isBtnEnable, setIsBtnEnable } = React.useContext(SortContext);
  const { mutate: updateSetMutation } = useUpdateSet({ onCompleted });
  const { handleCancel: uiUpdate } = useRemoveDesings();
  const [tempSearch, setTempSearch] = useState("");
  const [removeDesignModal, setRemoveDesignModal] = useState(false);
  const { setCreateBtn, setShowCollectionTrashIcon, collectionUpdate, setOpenCancelModal, setTrashModalOpen, setCollectionUpdate } = useGlobalContext();
  const navigate = useNavigate();
  const { id } = useParams();
  const location = useLocation();
  const [searchParams] = useSearchParams();
  const setNumber = searchParams.get("setNumber");

  // console.log("location====>>>",location)

  const dispatch = useDispatch();

  const isEditCatagoryData = useSelector(   
    (state) => state.editCategory.data
  );

  const archivedSetIds = useSelector(
    (state) => state.archiveSet.ids
  );

  const isBtnEnable = isEditCatagoryData.length > 0 || archivedSetIds.length > 0;

  // console.log("isEditCatagoryData====>>>>>",isEditCatagoryData)

  function handleCancel() {
    //to remove the changes from the frotend
    uiUpdate();
    sessionStorage.removeItem("removedDesignsBySet");
    sessionStorage.removeItem("RemoveCollectionDesign");
    dispatch(clearEditCategory("removedDesignsBySet"))
    setIsEdit("view");
    setIsEditClick(false);
    // setIsBtnEnable(false);
  }

  const handleCancelCollectionEdit = () => {
    if (collectionUpdate) {
      setOpenCancelModal(true);
    } else {
      setSearch("");
      setIsCollectionEdit("view");
      setShowCollectionTrashIcon(false);
      // localStorage.removeItem("tempCollectionRemoveData");
      setOpenCancelModal(false);
    }
  };

  const handleCollectionEditSave = async () => {
    let collectionToBeRemoved = JSON.parse(localStorage.getItem("tempCollectionRemoveData")) || [];
    let collectionToBeUpdate = JSON.parse(localStorage.getItem("tempCollectionUpdatedData")) || [];

    if (collectionToBeRemoved.length > 0) {
      setCollectionUpdate(false);
      let Data = await removeCollections(collectionToBeRemoved);
      if (Data.status === 200) {
        localStorage.removeItem("tempCollectionRemoveData");
        toast.success(Data.message, {
          autoClose: 1000,
          hideProgressBar: false,
        });
        queryClient.removeQueries("collectionCountData");
        setIsCollectionEdit("view");
        setShowCollectionTrashIcon(false);
        navigate("/Collection");
      }
      setCollectionUpdate(true);
    }

    if (collectionToBeUpdate.length > 0) {
      let Data = await updateCollectionNames(collectionToBeUpdate);
      if (Data.status === 200) {
        localStorage.removeItem("tempCollectionUpdatedData");
        toast.success(Data.message, {
          autoClose: 1000,
          hideProgressBar: false,
        });
        setIsCollectionEdit("view");
        setShowCollectionTrashIcon(false);
      }
    }
  };

  const { createPayload } = useRemoveDesings();

  const handleSave = () => {
    if (!id) {
      updateSetMutation(createPayload());
    } else {
      const data = JSON.parse(sessionStorage.getItem("removedDesignsBySet"));
      const ids = data?.map((item) => item?._id);
      const payload = { setsToRemoveDesignFrom: { [id]: ids } };
      updateSetMutation(payload);
    }
  };

  const btns = [
    {
      btnName: "Remove",
      bgColor: "#E77B7B",
      click: () => handleSave(),
    },
    {
      btnName: "Keep",
      bgColor: "#50C878",
      click: () => setRemoveDesignModal(false),
    },
  ];

  const handleSearch = () => {
    setSearch(tempSearch);
  };

  function onCompleted() {
    const removedDesignsCount = JSON.parse(sessionStorage.getItem("removedDesignsBySet")) || [];

    queryClient.removeQueries(["sets"]);
    queryClient.removeQueries(["setCountData"]);
    queryClient.removeQueries(["get-designs"]);
    localStorage.removeItem("archivedDesigns");
    sessionStorage.removeItem("removedDesignsBySet");
    dispatch(clearEditCategory("removedDesignsBySet"));

    setIsEdit("view");
    setIsEditClick(false);
    // setIsBtnEnable(false);
    // navigate(location?.state?.backPath);
    if (!id) {
      navigate("/Sets");
    } else {
      const updatedState = {
        ...location.state,
        name: [`${location.state.name[0].split(" - ")[0]} - ${location.state.name[0].split(" - ")[1] - removedDesignsCount.length}`], // Update the count here
      };
      navigate(`?setNumber=${setNumber}`, { state: updatedState });
    }
  }

  React.useEffect(() => {
    if (tempSearch === "") {
      setSearch("");
    }
  }, [tempSearch]);

  //for save btn enable/disable
  // useEffect(() => {
  //   const changesCount = () => {
  //     const removedDesigns = JSON.parse(sessionStorage.getItem("RemoveCollectionDesign")) || JSON.parse(sessionStorage.getItem("removedDesignsBySet")) || [];
  //     setIsBtnEnable(removedDesigns.length > 0 ? true : false);
  //   };

  //   changesCount();
  //   window.addEventListener("UpdateSubCategory", changesCount);

  //   return () => {
  //     window.removeEventListener("UpdateSubCategory", changesCount);
  //     setIsBtnEnable(false);
  //   };
  // }, []);

  return (
    <>
      <Box sx={{ flexGrow: 1 }} />
      {/* {isCollectionEdit === "click" && ( */}
      <Search
        sx={{
          display: "flex",
          alignItems: "center",
          paddingLeft: "10px",
          paddingRight: "4px",
          // border: "10px solid blue",
        }}
      >
        {/* Search Icon inside Input */}
        <SearchIconPlaceHolder sx={{ color: "gray", marginRight: "8px" }} />

        <StyledInputBase
          placeholder="Search By Set or Design Number"
          onChange={(e) => setTempSearch(e.target.value)}
          onKeyDown={(e) => {
            if (e.key === "Enter") {
              handleSearch();
            }
          }}
          value={tempSearch}
          inputProps={{ "aria-label": "search" }}
          sx={{ height: "40px", borderRadius: "5px" }}
        />

        <IconButton
          disableRipple
          disableFocusRipple
          sx={{
            color: "black",
            height: "34px",
            width: "69px",
            borderRadius: "5px",
            padding: "10px",
            background: "#000",
            fontFamily: "poppins",
            color: "#fff",
            fontWeight: "500",
            fontSize: "12px",
          }}
          onClick={search === "" ? handleSearch : () => setSearch("")}
        >
          {search === "" ? "Search" : "Clear"}
        </IconButton>
      </Search>
      {/* )} */}

      {isCollectionEdit === "click" ? (
        <StyledButton variant={collectionUpdate ? "save-change" : ""} onClick={handleCollectionEditSave} disabled={!collectionUpdate}>
          Save Changes
        </StyledButton>
      ) : (
        <StyledButton
          onClick={() => {
            if (location?.pathname === "/Sets") {
              handleSave();
              return;
            }
    
            !location.pathname.includes("Collection") ? setRemoveDesignModal(true) : setTrashModalOpen(true);
          }}
          disabled={isBtnEnable ? false : true}
          variant={isBtnEnable ? "save-change" : ""}
        >
          Save Changes
        </StyledButton>
      )}

      <CancelButton onClick={isCollectionEdit === "click" ? handleCancelCollectionEdit : handleCancel}>Cancel</CancelButton>

      <RemoveModal
        open={removeDesignModal}
        setOpen={setRemoveDesignModal}
        btnInfo={btns}
        heading={`Remove ${JSON.parse(sessionStorage.getItem("removedDesignsBySet"))?.length || ""} selected designs from set?`}
      />
    </>
  );
};

export default EditSetHeader;
